<template>
  <div v-frag>
    <CardIeaAppMain>
      <v-col cols="12">
        <h1 class="text-center">{{ text }}</h1>
        <h1 class="text-center" v-if="error">
          <v-btn text color="blue" @click="soporte()"
            ><h1 class="text-center">Aquí</h1></v-btn
          >
        </h1>
      </v-col>
    </CardIeaAppMain>
    <v-dialog
      v-model="dialogOK"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5 justify-center">
          Pago existoso!
        </v-card-title>

        <v-card-text>
          Gracias por realizar su pago de <strong>${{monto}}</strong>, usted será redirigido en <strong>{{seconds}}</strong> segundos..
          <p class="d-flex justify-center mb-6">
            <v-icon size="100" color="green">mdi-checkbox-marked-circle-outline</v-icon>
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogError"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5 justify-center">
          Pago fallido!
        </v-card-title>

        <v-card-text>
          <p class="d-flex justify-center mb-6">Ocurrió un error al realizar el pago, porfavor intente mas tarde</p>
          <p class="d-flex justify-center mb-6">
            <v-icon size="100" color="red">mdi-close-circle-outline</v-icon>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="tryPayment()"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
export default {
  name: "Circuito",
  components: {
    CardIeaAppMain
  },
  mounted() {
    this.error = false;
    if (this.$route.params.id) {
      this.$API
        .get({
          url: "circuito/show/" + this.$route.params.id,
          data: {}
        })
        .then(res => {
          this.$router.replace({ name: "CircuitoPreInscripcion", params:{id:this.$route.params.id} });
          console.log(res)
          //this.$store.dispatch("circuito", res.uuid);
          //setTimeout(() => {
            
            // if (res) {
            //   if (res.PagoPrimero == 1) {
            //     this.$router.replace({ name: "CircuitoPreInscripcion" });
            //   } else {
            //     this.$router.replace({ name: "CircuitoInscripcion" });
            //   }
            // }
          //}, 3000);
        })
        .catch(err => {
          this.error = true;
          if (err.response.status == 404) {
            this.text =
              "La Inscripción no existe... , Si Ustéd está teniendo problemas, deje su consulta en Soporte llendo";
          }
        });
    }

    /*if (this.$route.params.preinscrito) {
      this.searchPreinscrito(this.$route.params.preinscrito);
    }*/
  },
  data: () => ({
    text: "Cargando datos del Circuito...",
    error: false,
    dialogOK:false,
    dialogError:false,
    id:null,
    idML:null,
    monto:0,
    seconds:8,
    interval:1000,
    timer:null
  }),
  methods: {
    startime(){
      const self = this;  
      this.timer = setInterval(function() {
        self.seconds--;
        console.log(self.seconds)
        if (self.seconds <= 0) {
          clearInterval(self.timer);
          self.dialogOK = false;
          self.$router.replace({ name: "CircuitoInscripcion", params:{preinscrito:self.idML, id:self.id}});

        }
      }, this.interval);
    },
    soporte() {
      setTimeout(() => {
        if (this.$DEBUG) {
          window.location.href =
            "http://localhost/iea-pro/public.consultasGenerales.php";
        } else {
          window.location.href =
            "https://sistemaiea.com/public.consultasGenerales.php";
        }
      }, 2000);
    },
    tryPayment(){
      this.dialogError = false;
      this.$router.replace({ name: "CircuitoPago", params:{id:this.id,idML:this.idML} });
    },
    searchPreinscrito(preinscrito) {
      this.$API
        .get({
          url: "circuito/status-pago/" + preinscrito,
          data: {}
        })
        .then(res => {
          if (res) {
            console.log(res)
            this.id = res.circuito.uuid;
            this.idML = preinscrito;
            this.monto = res.Monto;
            if (res.ML_Estado == "Exito: Pendiente Verificar") {
              this.$store.dispatch("preinscrito", preinscrito);
              this.dialogOK = true;
              this.startime();
              //this.$router.replace({ name: "CircuitoInscripcion", params:{preinscrito:preinscrito, id:res.circuito.uuid}});
            } else {
              this.$store.dispatch("preinscrito", preinscrito);
              
              this.dialogError = true;
              //this.$router.replace({ name: "CircuitoPago", params:{id:res.circuito.uuid,idML:preinscrito} });
            }
            
          }
        })
        .catch(err => {
          if (err.response.status == 404) {
            this.$store.dispatch("preinscrito", "");
            setTimeout(() => {
              this.$router.replace({
                name: "Circuito",
                params: {
                  id: this.$store.getters.circuito
                }
              });
            }, 2000);
          }
        });
    }
  }
};
</script>
